import { createContext } from 'react';

export const AppdataContext = createContext(null);
export const AppdataDispatchContext = createContext(null);